import { Length } from "@shared/common/utils/length";

interface TrackTagProps {
  readonly trackLength: Length;
  readonly occupiedLength: Length;
  readonly isPassing?: boolean;
  readonly isBlocked?: boolean;
  readonly isThirdParty?: boolean;
}

export function TrackTag({
  trackLength,
  occupiedLength,
  isPassing = false,
  isBlocked = false,
  isThirdParty = false,
}: TrackTagProps): React.ReactElement {
  if (isBlocked) {
    return (
      <TractieTag color="yellow" title="Spoor buitendienst gesteld">
        <tractie-icon name="traffic-cone-warning" size="xs" />
        BTD
      </TractieTag>
    );
  }
  if (isPassing) {
    return (
      <TractieTag appearance="subtle" color="blue" title="Doorgaande trein">
        DRGD
      </TractieTag>
    );
  }
  if (isThirdParty) {
    return (
      <TractieTag appearance="subtle" color="yellow" title="Derde vervoerder">
        <tractie-icon name="question" size="xs" />
        DV
      </TractieTag>
    );
  }
  const leftOverLengthText = `${Math.round(trackLength.inMeters() - occupiedLength.inMeters())} m`;
  if (occupiedLength.inMillimeters() === 0) {
    return (
      <TractieTag color="gray" appearance="subtle">
        {leftOverLengthText}
      </TractieTag>
    );
  }
  if (occupiedLength.inMillimeters() > trackLength.inMillimeters()) {
    return (
      <TractieTag color="red" title="Spoorlengte overschreden">
        <tractie-icon name="alert-filled" size="xs" />
        {leftOverLengthText}
      </TractieTag>
    );
  }
  return (
    <TractieTag appearance="subtle" color="green">
      {leftOverLengthText}
    </TractieTag>
  );
}

type TagProps = {
  readonly color?: string;
  readonly appearance?: "subtle";
  readonly title?: string;
  readonly children?: React.ReactNode;
};

function TractieTag({ color, appearance, title, children }: TagProps): React.ReactElement {
  return (
    <tractie-tag color={color} appearance={appearance} title={title} size="m">
      <div className="flex items-center justify-center gap-0.5">{children}</div>
    </tractie-tag>
  );
}
